import React from 'react'
import * as css from './Tabs.module.css'
import clsx from 'clsx'

const Tabs = ({ tabs, state }) => {
	const [$active, set$active] = state


	return (
		<nav className="flex justify-around flex-col md:flex-row gap-4 md:gap-9 my-24">
			{tabs?.map((tab, key) => (
				<button
					className={clsx(css.btn, 'grow action _h font-normal', $active === key && css.active)}
					onClick={() => set$active(key)}
					key={key}
				>
					{tab.heading.text}
				</button>
			))}
		</nav>
	)
}

export default Tabs
